import { AppAction } from '../types';
import { RoofTopResource } from './roofTopManagementTypes';

export const ROOF_TOP_MANAGEMENT_SET_MY_ROOF_TOP =
  'ROOF_TOP_MANAGEMENT_SET_MY_ROOF_TOP';
export const SET_VALID_ROOF_TOP_BY_ID = 'SET_VALID_ROOF_TOP_BY_ID';
export const ROOF_TOP_MANAGEMENT_SET_ROOF_TOPS =
  'ROOF_TOP_MANAGEMENT_SET_ROOF_TOPS';

export interface setRoofTopsActionType {
  type: typeof ROOF_TOP_MANAGEMENT_SET_ROOF_TOPS;
  payload: RoofTopResource[];
}

export interface setMyRoofTopActionType {
  type: typeof ROOF_TOP_MANAGEMENT_SET_MY_ROOF_TOP;
  payload: RoofTopResource;
}

export interface SetValidRoofTopByIdActionType {
  type: typeof SET_VALID_ROOF_TOP_BY_ID;
  payload: RoofTopResource;
}

export type RoofTopManagementAction =
  | setMyRoofTopActionType
  | SetValidRoofTopByIdActionType
  | setRoofTopsActionType;

export type RoofTopManagementThunk<T = void> = AppAction<
  RoofTopManagementAction,
  T
>;
